import moment from "moment";
import { InlineRangeCalendar } from "PFComponents/calendar/inline_calendar";
import { useAvailabilityRangeOptions } from "PFCore/hooks/use_availability_range_options";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { FilterWithDefaults, Range } from "PFTypes";
import { RefObject } from "react";
import { useTranslation } from "react-i18next";

type AvailabilityRangeItemProps = {
  handleChange: (value: Range) => void;
  filter: FilterWithDefaults;
  error?: string;
  portalRef?: RefObject<HTMLDivElement>;
  disabled?: boolean;
};

export const AvailabilityRangeItem = ({
  filter,
  handleChange,
  error,
  portalRef,
  disabled
}: AvailabilityRangeItemProps) => {
  const { t } = useTranslation();
  const { formatISODate } = useDateFormatter();
  const value = (filter.value || {}) as Partial<Range>;
  const { start, end } = value;

  const { options, availabilityMatchMonthsLimit } = useAvailabilityRangeOptions(formatISODate, t);

  return (
    <div style={{ padding: "0px 10px", margin: "0px 10px", position: "relative" }}>
      <InlineRangeCalendar
        startDate={start ? formatISODate(start) : ""}
        minDate={formatISODate()}
        maxDate={formatISODate(moment().add(availabilityMatchMonthsLimit || 6, "months"))}
        endDate={end ? formatISODate(end) : ""}
        label={filter.title}
        required={filter.required}
        style={{ marginLeft: -10 }}
        handleChange={(start, end) =>
          handleChange({
            start: formatISODate(start),
            end: formatISODate(end)
          })
        }
        letClear={!filter.required}
        options={options}
        error={error}
        portalRef={portalRef}
        disabled={disabled}
      />
    </div>
  );
};
